// import api from '@/libs/axios'
import { uploader } from '@/mixins'
import api from '@/libs/axios'

const state = {
}

const mutations = {
}

const actions = {
	async importTieredPrice(_, { file }) {
		await uploader.methods.uploadCustom({
			file,
			apiUrl: '/api/products/skus/import-tiered-price',
			fileParamName: 'file',
		})
	},

	async exportTieredPriceExcel(_, { priceTableId, storeId, skuId }) {
		const params = { priceTableId, storeId, skuId }
		const response = await api.get('/api/products/skus/export-tiered-price', {
			params,
			responseType: 'blob',
		})
		return response.data
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
